(ns minorodata.health.subs
  (:require [re-frame.core :as re-frame]))

(re-frame/reg-sub
 :health.subs/dashboard-url
 (fn [db [_ id]]
   (get-in db [:dashboards id])))
